import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui';
import { Badge } from '@/components/ui';
import { InternationalKeyword } from '@/data/mocks/international';
import { Globe, TrendingUp, Target } from 'lucide-react';

interface KeywordsTableProps {
  keywords: InternationalKeyword[];
  language: 'en' | 'es' | 'pt';
}

export const KeywordsTable: React.FC<KeywordsTableProps> = ({ keywords, language }) => {
  const getOpportunityColor = (opportunity: string) => {
    switch (opportunity) {
      case 'high':
        return 'success';
      case 'medium':
        return 'warning';
      case 'low':
        return 'default';
      default:
        return 'default';
    }
  };

  const getPositionColor = (position: number) => {
    if (position <= 3) return 'success';
    if (position <= 10) return 'warning';
    return 'default';
  };

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Mot-clé</TableHead>
            <TableHead className="text-right">Volume</TableHead>
            <TableHead className="text-center">Position</TableHead>
            <TableHead>Intent</TableHead>
            <TableHead>URL Cible</TableHead>
            <TableHead className="text-right">Opportunité</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {keywords.map((keyword) => (
            <TableRow key={keyword.id}>
              <TableCell>
                <div className="flex items-center gap-2">
                  <Globe className="w-4 h-4 text-gray-400" />
                  <span className="font-medium">{keyword.keyword}</span>
                </div>
              </TableCell>
              <TableCell className="text-right">
                <div className="flex items-center justify-end gap-2">
                  <TrendingUp className="w-4 h-4 text-gray-400" />
                  {keyword.volume.toLocaleString()}
                </div>
              </TableCell>
              <TableCell className="text-center">
                <Badge variant={getPositionColor(keyword.position)}>
                  #{keyword.position}
                </Badge>
              </TableCell>
              <TableCell>
                <Badge variant="outline">
                  {keyword.intent}
                </Badge>
              </TableCell>
              <TableCell>
                <span className="text-sm text-gray-600">
                  {keyword.targetUrl}
                </span>
              </TableCell>
              <TableCell className="text-right">
                <Badge variant={getOpportunityColor(keyword.opportunity)}>
                  {keyword.opportunity}
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
